import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IDisbursementHistoryDetailResponse,
  IDisbursementHistoryReceiptResponse,
} from '@merchant-portal/app/models/disbursement/disbursement-history/disbursement-history.interface';
import { environment } from '@merchant-portal/environments/environment';
import { Observable, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DisbursementHistoryDetailApiService {
  public backend_portal_url = environment.backend_portal_url + 'api/v1/disbursements/';

  constructor(private http: HttpClient) {}

  getDisbursementHistoryDetail(id: string, subMerchantId?: string): Observable<IDisbursementHistoryDetailResponse> {
    let params = new HttpParams();
    if (subMerchantId) {
      params = params.set('subMerchantId', subMerchantId);
    }
    return this.http.get<IDisbursementHistoryDetailResponse>(this.backend_portal_url + id, { params }).pipe(
      catchError(val => {
        return of(val);
      })
    );
  }

  downloadReceipt(id: string, subMerchantId?: string): Observable<IDisbursementHistoryReceiptResponse> {
    let params = new HttpParams();
    if (subMerchantId) {
      params = params.set('subMerchantId', subMerchantId);
    }
    return this.http
      .get<IDisbursementHistoryReceiptResponse>(this.backend_portal_url + id + '/receipt', { params })
      .pipe(
        catchError(val => {
          return of(val);
        })
      );
  }
}
